<template lang="html">
  <section
    class="question-tooltip"
    @mouseover="showTooltip = true"
    @mouseleave="showTooltip = false"
  >
    <span v-if="triggerText">{{ triggerText }}</span>

    <font-awesome-icon
      v-if="tooltipText && (showOnMobile || isGtMobile)"
      v-tooltip="{
        content: tooltipText,
        trigger: 'manual',
        show: showTooltip,
      }"
      class="question-tooltip-icon"
      :icon="['fal', 'question-circle']"
      @click="handleClick"
    />
  </section>
</template>

<script>
import mobileDetection from '@/mixins/mobile-detection';

// TODO: Increase tap targets on the tooltip icon for mobile.
// TODO: Fix CSS when the tooltip goes to multiline on mobile. Looks ugly.
export default {
  name: 'QuestionTooltip',

  mixins: [mobileDetection],

  props: {
    showOnMobile: {
      type: Boolean,
      default: true,
    },

    tooltipText: {
      type: String,
      default: null,
    },

    triggerText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showTooltip: false,
    };
  },

  methods: {
    handleClick(event) {
      // If the tooltip is inside a `<label>`, this will prevent the form
      // control getting triggered as well.
      event.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
.question-tooltip {
  // We need to force the trigger text to be one line so that we can predictably
  // position the tooltip icon next to it.
  white-space: nowrap;
  position: relative;
  display: inline-block;
}

.question-tooltip-icon {
  $size: 14px;

  width: $size;
  height: $size;

  // We use absolute positioning + single line trigger text so that the tooltip
  // never overflows and becomes orphaned.
  position: absolute;
  top: 50%;
  right: -($size * 1.5);
  margin-top: -$size / 2;
  color: map-get($colors, 'grey');
}
</style>
